import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/closing';
export function PainPoints() {
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-84" data-mp="2lp54sq5qh0t5">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="26xmu97vn7yh6">
        <header className="text-center" data-id="element-86" data-mp="26wldqnvuyjs2">
          <h2 className="font-display text-3xl font-bold sm:text-4xl" style={{
          fontSize: "27px"
        }} data-id="element-87" data-mp="2bwhac22878xl">
            ¿Cuántas veces más vas a volver a empezar?
          </h2>
          <p className="mt-6 text-lg font-semibold text-primary-soft" style={{
          fontSize: "16px",
          fontWeight: "600",
          color: "#CBD5E1"
        }} data-id="element-88" data-mp="21z36r31eiemp">
            No es que te falten ganas de tener más orden.
          </p>
          <p className="mt-2 text-lg font-semibold text-primary-soft" data-id="element-89" data-mp="1sz6n5ftvc5yi">
            Te falta un sistema que te ayude a simplificar.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90" data-mp="3nd7llzliaqy2">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-danger-border/70 bg-danger-surface p-4 sm:p-5" data-id="element-91" data-mp="1z0orup29tpf8" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-92" data-mp="23sol5ynu5k2u" />
              <p className="text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-93" data-mp="1g2lyjy2ox6bm">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mx-auto mt-10 max-w-3xl text-center font-display text-2xl font-bold italic text-highlight sm:text-3xl" style={{
        fontSize: "22px"
      }} data-id="element-94" data-mp="1p30l10re4rgp">
          ¿Y si tuvieras un método listo para simplificar tu vida?
        </p>
      </div>
    </section>;
}